import { WORKING_ORDER } from "constants/action-types";
import { IWorkingOrderDraftPayload } from "types/working-order/draft";

export interface IDraftSaveAction {
    type: typeof WORKING_ORDER.DRAFTS.SAVE;
    payload: IWorkingOrderDraftPayload;
}

/** Should be triggered, when it is required to save draft order. */
export const saveDraftOrder = (payload: IDraftSaveAction["payload"]) => ({
    type: WORKING_ORDER.DRAFTS.SAVE.START,
    payload,
});
